import React from 'react';
interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}
const BaseIcon = ({
  size = 24,
  children,
  className,
  ...props
}: IconProps) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} {...props} data-id="element-49">
    {children}
  </svg>;
export const ChatBubblePhone = (props: IconProps) => <BaseIcon {...props} data-id="element-50">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" data-id="element-51" />
    <path d="M15 13.5c-.5.5-1.2.6-1.8.3-.8-.4-1.6-.9-2.2-1.5-.6-.6-1.1-1.4-1.5-2.2-.3-.6-.2-1.3.3-1.8l.8-.8c.3-.3.4-.8.2-1.2L10 4.8c-.2-.4-.7-.6-1.1-.4L7.6 5c-.7.3-1.1 1-1 1.8.3 2.5 1.5 4.8 3.3 6.6 1.8 1.8 4.1 3 6.6 3.3.8.1 1.5-.3 1.8-1l.6-1.3c.2-.4 0-.9-.4-1.1l-1.5-.8c-.4-.2-.9-.1-1.2.2l-.8.8z" data-id="element-52" />
  </BaseIcon>;
export const ArrowDown = (props: IconProps) => <BaseIcon {...props} data-id="element-53">
    <path d="M12 5v14M19 12l-7 7-7-7" data-id="element-54" />
  </BaseIcon>;
export const CarFront = (props: IconProps) => <BaseIcon {...props} data-id="element-55">
    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" data-id="element-56" />
    <circle cx="7" cy="17" r="2" data-id="element-57" />
    <path d="M9 17h6" data-id="element-58" />
    <circle cx="17" cy="17" r="2" data-id="element-59" />
  </BaseIcon>;
export const Key = (props: IconProps) => <BaseIcon {...props} data-id="element-60">
    <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4" data-id="element-61" />
    <path d="m21 2-9.6 9.6" data-id="element-62" />
    <circle cx="7.5" cy="15.5" r="5.5" data-id="element-63" />
  </BaseIcon>;
export const CreditCardCheck = (props: IconProps) => <BaseIcon {...props} data-id="element-64">
    <rect width="20" height="14" x="2" y="5" rx="2" data-id="element-65" />
    <line x1="2" x2="22" y1="10" y2="10" data-id="element-66" />
    <path d="m11 15 2 2 4-4" data-id="element-67" />
  </BaseIcon>;
export const ArrowsExchange = (props: IconProps) => <BaseIcon {...props} data-id="element-68">
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" data-id="element-69" />
    <path d="M3 3v5h5" data-id="element-70" />
    <path d="M21 12a9 9 0 1 0-9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" data-id="element-71" />
    <path d="M16 21v-5h5" data-id="element-72" />
  </BaseIcon>;
export const ArrowRight = (props: IconProps) => <BaseIcon {...props} data-id="element-73">
    <path d="M5 12h14M12 5l7 7-7 7" data-id="element-74" />
  </BaseIcon>;
export const StarAward = (props: IconProps) => <BaseIcon {...props} data-id="element-75">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-76" />
  </BaseIcon>;
export const Lightning = (props: IconProps) => <BaseIcon {...props} data-id="element-77">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" data-id="element-78" />
  </BaseIcon>;
export const SpeechBubbles = (props: IconProps) => <BaseIcon {...props} data-id="element-79">
    <path d="M14 22h-3a8 8 0 0 1-8-8 8 8 0 0 1 8-8h3" data-id="element-80" />
    <path d="M14 6a8 8 0 0 1 8 8 8 8 0 0 1-8 8" data-id="element-81" />
    <path d="M9 14h6" data-id="element-82" />
    <path d="M9 10h6" data-id="element-83" />
  </BaseIcon>;
export const DocumentPen = (props: IconProps) => <BaseIcon {...props} data-id="element-84">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" data-id="element-85" />
    <path d="M14 2v6h6" data-id="element-86" />
    <path d="m16 13-3.5 3.5-2 .5.5-2L14.5 11.5a1.4 1.4 0 0 1 2 2Z" data-id="element-87" />
  </BaseIcon>;
export const PhoneSignal = (props: IconProps) => <BaseIcon {...props} data-id="element-88">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" data-id="element-89" />
    <path d="M12 18h.01" data-id="element-90" />
    <path d="M2 12h2" data-id="element-91" />
    <path d="M20 12h2" data-id="element-92" />
    <path d="M12 2v2" data-id="element-93" />
  </BaseIcon>;
export const SteeringWheel = (props: IconProps) => <BaseIcon {...props} data-id="element-94">
    <circle cx="12" cy="12" r="10" data-id="element-95" />
    <circle cx="12" cy="12" r="2" data-id="element-96" />
    <path d="M12 2v8" data-id="element-97" />
    <path d="m4.93 19.07 5.66-5.66" data-id="element-98" />
    <path d="m19.07 19.07-5.66-5.66" data-id="element-99" />
  </BaseIcon>;
export const ChatBubble = (props: IconProps) => <BaseIcon {...props} data-id="element-100">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" data-id="element-101" />
  </BaseIcon>;